import { render, staticRenderFns } from "./AddNormal.vue?vue&type=template&id=708de3d8&scoped=true&"
import script from "./AddNormal.vue?vue&type=script&lang=js&"
export * from "./AddNormal.vue?vue&type=script&lang=js&"
import style0 from "./AddNormal.vue?vue&type=style&index=0&id=708de3d8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708de3d8",
  null
  
)

export default component.exports